import React from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { formatDate } from "../../utils";

const MyInfoCard = (props) => {
  const {
    studentName,
    studentClass,
    fatherName,
    contact,
    address,
    school,
    nextDue,
    dob,
    avatarUrl,
  } = props;

  function formatDateWithColorAndMessage(dateString) {
    const currentDate = new Date();
    const dueDate = new Date(dateString);
    const dateDiff = Math.ceil((dueDate - currentDate) / (1000 * 60 * 60 * 24));

    if (dateDiff < 7 && dateDiff > 0) {
      // Yellow color and message
      return (
        <>
          <span style={{ color: "orange" }}>
            <span className="fw-bold">
              {formatDate(dueDate)} <br />{" "}
            </span>
            Due date in next {dateDiff} days
          </span>
        </>
      );
    } else if (dateDiff === 0) {
      // Red color and message
      return (
        <>
          <span style={{ color: "red" }}>
            <span className="fw-bold">
              {formatDate(dueDate)} <br />{" "}
            </span>
            Due date is today
          </span>
        </>
      );
    } else if (dateDiff < 0) {
      // Red color and message
      return (
        <>
          <span style={{ color: "red" }}>
            <span className="fw-bold">
              {formatDate(dueDate)} <br />{" "}
            </span>
            Due date exceeded by {-1 * dateDiff} days
          </span>
        </>
      );
    } else {
      return (
        <>
          <span style={{ color: "green" }}>
            <span className="fw-bold">
              {formatDate(dueDate)} <br />{" "}
            </span>
            Due date in next {dateDiff} days
          </span>
        </>
      );
    }
  }

  const avatarStyle = {
    width: "9rem",
    height: "9rem",
    backgroundColor: "#1976D2",
    fontSize: "4rem",
  };

  const personalInfo = [
    { label: "Father's Name", value: fatherName },
    { label: "Contact", value: contact },
    { label: "Address", value: address },
    { label: "School", value: school },
    { label: "DOB", value: dob },
  ];

  const cardStyle = {
    display: "flex",
    flexDirection: "column", // Change to column for mobile
    justifyContent: "space-between",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "16px",
  };

  const dividerStyle = {
    margin: "8px 0", // Adjust margin for mobile
  };

  return (
    <Container>
      <Card style={cardStyle}>
        <div className="d-flex flex-direction-row my-2 mx-2">
          <Avatar alt={studentName} src={avatarUrl} style={avatarStyle}>
            {studentName.charAt(0)}
          </Avatar>
          <Typography variant="h6" className="py-4 text-center mx-auto">
            {studentName}
            <br/>
            Class: {studentClass}
          </Typography>
        </div>
        <Divider style={dividerStyle} />
        <div>
          <Table>
            <TableBody>
              {personalInfo.map((info, index) => (
                <TableRow key={index}>
                  <TableCell>{info.label}</TableCell>
                  <TableCell>{info.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Divider style={dividerStyle} />
          <Typography variant="h6" className="px-3">
            Payment Information
          </Typography>
          <Typography variant="body2" className="px-3 pb-3">
            <strong>Next Payment:</strong>{" "}
            {formatDateWithColorAndMessage(nextDue)}
          </Typography>
        </div>
      </Card>
    </Container>
  );
};

export default MyInfoCard;
